import React from 'react';
import './Footer.css';
import logo from '../Assets/techb_logo.webp';

const services = [
  { label: 'Solar Rooftop Installation', href: '#solar' },
  { label: 'Battery Storage Systems',    href: '#battery' },
  { label: 'Electrical Infrastructure',  href: '#services' },
  { label: 'Energy Consultation',        href: '#services' },
];

const company = [
  { label: 'About Us',       href: '#about' },
  { label: 'Contact Us',     href: '#contact' },
  { label: 'Terms & Conditions',     href: '#' },
  { label: 'Privacy Policy', href: '#' },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <a href="#" className="navbar__logo">
            <img src={logo} alt="TechB Energy" className="navbar__logo-img" />
          </a>
          <p>
            Empowering a sustainable future through solar installation
            and energy infrastructure solutions across Maharashtra.
          </p>
          <div className="footer__contact-quick">
            <a href="tel:+917498248818">📞 +91 7498248818</a>
            <a href="mailto:info@techbenergy.com">✉️ info@techbenergy.com</a>
          </div>
        </div>

        <div className="footer__col">
          <h3 className="footer__col-heading">Services</h3>
          <ul>
            {services.map((s) => (
              <li key={s.label}><a href={s.href}>{s.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h3 className="footer__col-heading">Company</h3>
          <ul>
            {company.map((c) => (
              <li key={c.label}><a href={c.href}>{c.label}</a></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} TechB Energy LLP. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;